// @flow
import { defineMessages } from 'react-intl';

const messages = defineMessages({
    downDescription: {
        defaultMessage: 'Select next item',
        description: 'Description for keyboard shortcut to select next item in the file list',
        id: 'boxui.core.selection.downDescription',
    },
    upDescription: {
        defaultMessage: 'Select previous item',
        description: 'Description for keyboard shortcut to select previous item in the file list',
        id: 'boxui.core.selection.upDescription',
    },
    shiftXDescription: {
        defaultMessage: 'Select current item',
        description: 'Description for keyboard shortcut to select previous item in the file list',
        id: 'boxui.core.selection.shiftXDescription',
    },
    shiftUpDescription: {
        defaultMessage: 'Add previous item to current selection',
        description: 'Description for keyboard shortcut to add previous item to current selection in the file list',
        id: 'boxui.core.selection.shiftUpDescription',
    },
    shiftDownDescription: {
        defaultMessage: 'Add next item to current selection',
        description: 'Description for keyboard shortcut to add next item to current selection in the file list',
        id: 'boxui.core.selection.shiftDownDescription',
    },
    selectAllDescription: {
        defaultMessage: 'Select all items',
        description: 'Description for keyboard shortcut to select all items in the file list',
        id: 'boxui.core.selection.selectAllDescription',
    },
    deselectAllDescription: {
        defaultMessage: 'Deselect all items',
        description: 'Description for keyboard shortcut to deselect all items in the file list',
        id: 'boxui.core.selection.deselectAllDescription',
    },
});

export default messages;
